import * as actionTypes from "./constants";

const initialState = {
  processing: false,
  error: false,
};

export default function loadMetricsReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.LOAD_METRICS_SUCCESS_ACTION:
      return {
        ...state,
        loadMetrics: action.payload.rows,
        loadMetricsCount: action.payload.count,
      };
    case actionTypes.CARGOSIZE_SUCCESS_ACTION: {
      console.log(action.payload.rows);

      return {
        ...state,
        cargoSize: action.payload.rows.filter(function (cargosize) {
          return cargosize.id !== "61cc1222aed5470e5c542095";
        }),
      };
    }
    default:
      return {
        ...state,
      };
  }
}
